export const contactsData = {
    email: 'sksunidhi2019@gmail.com',
    phone: '+915588776600',
    address: 'Bengaluru, India',

    sheetAPI: ''
}
